/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { IScrollerKeyboardListener_$type } from "igniteui-react-core";
/**
 * @hidden
 */
var DataGridScrollerKeyboardListener = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataGridScrollerKeyboardListener, _super);
    function DataGridScrollerKeyboardListener(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.a = a;
        return _this;
    }
    DataGridScrollerKeyboardListener.prototype.onDownArrow = function (a, b) {
        return this.a.ik(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onEnd = function (a, b) {
        return this.a.il(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onHome = function (a, b) {
        return this.a.iq(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onLeftArrow = function (a, b) {
        return this.a.is(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onPageDown = function (a, b) {
        return this.a.it(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onPageUp = function (a, b) {
        return this.a.iu(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onRightArrow = function (a, b) {
        return this.a.iv(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onTab = function (a, b) {
        return this.a.ix(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onUpArrow = function (a, b) {
        return this.a.iy(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onWheel = function () {
        this.a.te();
    };
    DataGridScrollerKeyboardListener.prototype.onEnter = function (a, b) {
        return this.a.im(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onEscape = function () {
        return this.a.io();
    };
    DataGridScrollerKeyboardListener.prototype.onF2 = function () {
        return this.a.ip();
    };
    DataGridScrollerKeyboardListener.prototype.onSpace = function (a, b) {
        return this.a.iw(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onKeyDown = function (a, b, c) {
        return this.a.ir(a, b, c);
    };
    DataGridScrollerKeyboardListener.$t = markType(DataGridScrollerKeyboardListener, 'DataGridScrollerKeyboardListener', Base.$, [IScrollerKeyboardListener_$type]);
    return DataGridScrollerKeyboardListener;
}(Base));
export { DataGridScrollerKeyboardListener };
//# sourceMappingURL=DataGridScrollerKeyboardListener.js.map
